import { render, staticRenderFns } from "./riderThirdPartyReviewPage.vue?vue&type=template&id=484588dd&scoped=true"
import script from "./riderThirdPartyReviewPage.vue?vue&type=script&lang=js"
export * from "./riderThirdPartyReviewPage.vue?vue&type=script&lang=js"
import style0 from "./riderThirdPartyReviewPage.vue?vue&type=style&index=0&id=484588dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484588dd",
  null
  
)

export default component.exports